var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserKyc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10005_63114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8498 14.2857H13.7214C11.032 14.2945 8.45512 15.4262 6.55342 17.4336C4.65172 19.441 3.57965 22.1611 3.57129 25V75C3.57965 77.8389 4.65172 80.559 6.55342 82.5664C8.45512 84.5738 11.032 85.7055 13.7214 85.7143H89.8498C92.5392 85.7055 95.116 84.5738 97.0177 82.5664C98.9194 80.559 99.9915 77.8389 99.9999 75V25C99.9915 22.1611 98.9194 19.441 97.0177 17.4336C95.116 15.4262 92.5392 14.2945 89.8498 14.2857ZM34.0216 33.9314C35.5275 33.9314 36.9995 34.4027 38.2516 35.2859C39.5037 36.169 40.4796 37.4242 41.0559 38.8928C41.6322 40.3614 41.783 41.9774 41.4892 43.5364C41.1954 45.0955 40.4702 46.5275 39.4054 47.6516C38.3406 48.7756 36.9839 49.541 35.507 49.8511C34.03 50.1613 32.4991 50.0021 31.1079 49.3938C29.7166 48.7855 28.5275 47.7553 27.6909 46.4336C26.8542 45.1119 26.4077 43.5581 26.4077 41.9685C26.456 39.8529 27.2736 37.8381 28.6912 36.3418C30.1087 34.8454 32.0174 33.9823 34.0216 33.9314ZM49.2494 66.0742H18.7991V61.7907C18.7991 56.4308 28.9492 53.7536 34.0269 53.7536C39.1046 53.7536 49.2547 56.4308 49.2547 61.7907L49.2494 66.0742ZM84.7774 63.397H59.4153V55.3599H84.7774V63.397ZM84.7774 47.3228H59.4153V39.2857H84.7774V47.3228Z",
    fill: "#4D3ECC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10005_63114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserKyc);
export default __webpack_public_path__ + "static/media/user-kyc.0437a40b74880af85c59b2116fdcdeb9.svg";
export { ForwardRef as ReactComponent };